import type { ReactNode } from 'react';

/**
 * Bọc màn mobile (thống kê, cài đặt SRS, tài khoản, comeback) trong một panel web.
 * `fill` (điện thoại): cao bằng vùng nội dung thay vì chiều cao cố định của desktop.
 */
export function WebPanel({ width = 760, height = 660, fill = false, children }: { width?: number; height?: number; fill?: boolean; children?: ReactNode }) {
  return (
    <div
      style={{
        maxWidth: width,
        background: 'var(--surface-page)',
        border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-card)',
        overflow: 'hidden',
        height: fill ? 'calc(100dvh - 56px - 58px - 48px - env(safe-area-inset-bottom, 0px))' : height,
        minHeight: fill ? 420 : undefined,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </div>
  );
}
